module.exports = __webpack_public_path__ + "static/img/pmps.7344e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT001/pmps.png
// module id = 32ce
// module chunks = 1